import { WSGrid, WSList } from "@wingspanhq/fe-component-library";
import { DataItem } from "../../../shared/components/DataItem";

export const InstantPayoutPayoutUS: React.FC = () => {
  return (
    <WSList gap="XL">
      <WSGrid gutter="XL">
        <WSGrid.Item span="6">
          <DataItem label="Instant payout service" value="RTP" />
        </WSGrid.Item>
        <WSGrid.Item span="6">
          <DataItem label="Delivery" value="Near real time (up to 90 mins)" />
        </WSGrid.Item>
      </WSGrid>
    </WSList>
  );
};
